/** Список полей роли */
const columnDataGridRole = [
  {
    dataField: 'roleId',
    dataType: 'number',
    caption: 'ID',
    width: 65
  },
  {
    dataField: 'roleName',
    dataType: 'string',
    caption: 'Название',
    width: 120
  },
  {
    dataField: 'description',
    dataType: 'string',
    caption: 'Описание',
    width: 200
  }
];

export default columnDataGridRole;
